var $8f856f365523e06b$exports = {};
$8f856f365523e06b$exports = {
    "alert": `Alerte`,
    "dismiss": `Rejeter`
};


export {$8f856f365523e06b$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
